// @owners { team: patient-fulfillment }
import { useCartNextAvailableDate } from '~shared/features/cart/hooks/useCartNextAvailableDate';
import { useQueryShipmentFeesAvailable } from '~shared/queries';
import { useOrderBundlingOptionsCurrentRoute } from '../../../order-bundling';
import { getFormattedDate } from './utils';

export const useBundledEarliestAvailableDate = () => {
  const { earliestAvailableDate } = useCartNextAvailableDate();
  const { earliestUpcomingShipment } = useOrderBundlingOptionsCurrentRoute();
  const formattedEarliestAvailableDate = getFormattedDate(earliestAvailableDate);
  const earliestAvailableDateIsBeforeOrderBundlingDate =
    !!earliestUpcomingShipment && earliestAvailableDate < earliestUpcomingShipment.date;
  const { dateToFeeHash } = useQueryShipmentFeesAvailable();

  const earliestAvailableDateHasDeliveryFee = dateToFeeHash[earliestAvailableDate];
  const showEarliestAvailableDate =
    !!formattedEarliestAvailableDate &&
    !!earliestAvailableDateIsBeforeOrderBundlingDate &&
    !earliestAvailableDateHasDeliveryFee;

  return { showEarliestAvailableDate, formattedEarliestAvailableDate, earliestAvailableDateIsBeforeOrderBundlingDate };
};
